const formatPhoneNumber = (number) => {
  const cleaned = ('' + number).replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }
  return number;
};

const validatePhone = (newPhone) => {
  if (!newPhone) return false;
  
  let cleaned = ('' + newPhone).replace(/[^\d]/g, '');
  
  // Check length and numeric validity
  if (cleaned.length !== 10 || !/^\d{10}$/.test(cleaned)) {
    return false;
  }
  
  const stage = process.env.REACT_APP_MR_STAGE;
  if (stage !== 'dev' && stage !== 'qa') {
    const invalidPatterns = [
      /^[01]\d{9}$/, // 0XXXXXXXXX OR 1XXXXXXXXX
      /^\d{3}[01]\d{6}$/, // XXX0XXXXXX OR XXX1XXXXXX
      /^\d{1}11\d{7}$/, // X11XXXXXXX
      /^\d{4}11\d{4}$/, // XXXX11XXXX
      /^\d{3}555\d{4}$/ // XXX555XXXX
    ];
    
    if (invalidPatterns.some(pattern => pattern.test(cleaned))) {
      return false;
    }
  }
  
  return cleaned;
}

const justNumbers = (fieldValue) => {
  const inputValue = fieldValue;
  const cleanedValue = inputValue.replace(/\D/g, '');
  return cleanedValue
}

export { formatPhoneNumber, validatePhone, justNumbers }